import axios from '../../plugins/axios'

export const createBusinessGroup = (_, { data }) => {
  return axios.post('/api/business-group', data)
    .catch(err => err.response )
}


export const getBusinessGroup = ({ commit }, { groupId }) => {
  return axios.get(`/api/business-group/${groupId}`)
    .then((res) => {
      commit('SET_BUSINESS_GROUP', res.data)
      return res
    })
    .catch(err => err.response )
}


export const listBusinessGroups = ({ commit }, { params } = {}) => {
  return axios.get('/api/business-group', { params })
    .then(res => {
      commit('SET_BUSINESS_GROUPS', res.data)
      return res
    })
    .catch(err => err.response)
}


export const deleteBusinessGroup = (_, { groupId }) => {
  return axios.delete(`/api/business-group/${groupId}`)
    .catch(err => err.response )
}


export const updateBusinessGroup = (_, { data, groupId }) => {
  return axios.put(`/api/business-group/${groupId}`, data)
    .catch(err => err.response )
}
